<template>
  <div>
    <el-form
      :rules="rules"
      ref="ruleForm"
      :model="ruleForm"
      label-position="top"
      label-width="100px"
      class="formBox"
    >
      <!-- <el-form-item label="园区" prop="park_id">
        <el-select
          filterable
          @change="changePark"
          v-model="ruleForm.park_id"
          placeholder="请选择园区"
          :disabled="userInfo.is_super != 1"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in parkList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="报事企业" prop="company_id">
        <el-select
          filterable
          @change="changeCompany"
          v-model="ruleForm.company_id"
          placeholder="请选择报事企业"
          :disabled="userInfo.type == 2"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in companyList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报事人" prop="user_id">
        <el-select
          filterable
          :disabled="ruleForm.company_id == ''"
          v-model="ruleForm.user_id"
          placeholder="请选择报事人"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in ageUserList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报事地点" prop="address" class="w50">
        <el-input
          v-model="ruleForm.address"
          placeholder="请输入报事地点"
        ></el-input>
      </el-form-item>
      <el-form-item label="工单原因类型的大类" prop="maintenance_type_id">
        <el-select
          filterable
          @change="changeType"
          v-model="ruleForm.maintenance_type_id"
          placeholder="请选择工单原因类型的大类"
        >
          <el-option
            :label="item.title"
            :value="item.id"
            v-for="(item, index) in maintenanceList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工单原因类型的小类" prop="maintenance_type_son_id">
        <el-select
          filterable
          :disabled="ruleForm.maintenance_type_id == ''"
          v-model="ruleForm.maintenance_type_son_id"
          placeholder="请选择工单原因类型的小类"
          @change="reasonSmall"
          clearable
        >
          <el-option
            :label="item.title"
            :value="item.id"
            v-for="(item, index) in maintenanceTwoList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理人" prop="dispose_user_id">
        <el-select
          filterable
          v-model="ruleForm.dispose_user_id"
          placeholder="请选择处理人"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in ByUserList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="紧急程度" prop="level">
        <el-select
          filterable
          v-model="ruleForm.level"
          placeholder="请选择紧急程度"
        >
          <el-option
            :label="item.title"
            :value="item.id"
            v-for="(item, index) in levelList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="描述" prop="des" class="w50">
        <el-input
          type="textarea"
          v-model="ruleForm.des"
          placeholder="请输入描述"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片" prop="image">
        <el-upload
          name="file[]"
          :data="{ type: 'image' }"
          ref="upload"
          :class="{ disabled: uploadDisabled }"
          :headers="{ token: token }"
          :action="ossUpload"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess"
          :on-change="handleEditChange"
          accept=".jpg,.png,.jpeg"
        >
          <i class="el-icon-plus"></i> </el-upload
        ><!-- 已修改 -->
        <el-dialog :append-to-body="true" :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >立即创建</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  delImage,
  maintenanceType,
  openPark,
  openCompany,
  openAgoUser,
  addProprietor,
  getByUser,
} from "@/api/index";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ruleForm: {
        park_id: "",
        user_id: "",
        company_id: "",
        maintenance_type_id: "",
        source: 2,
        level:1,
        des: "",
        type: 2,
        image: [],
        address: "",
        dispose_user_id: "",
        maintenance_type_son_id: "",
      },
      fileList: [],
      levelList:[
					{
						id:1,
						title:'普通'
					},
					{
						id:2,
						title:'严重'
					},
					{
						id:3,
						title:'紧急'
					}
			],
      file: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      uploadDisabled: false,
      ossUpload: this.$store.state.ossUpload,
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "blur" }],
        user_id: [{ required: true, message: "请选择报事人", trigger: "blur" }],
        level: [{ required: true, message: "请选择紧急程度", trigger: "blur" }],
        company_id: [
          { required: true, message: "请选择报事企业", trigger: "blur" },
        ],
        maintenance_type_id: [
          {
            required: true,
            message: "请选择工单原因类型的大类",
            trigger: "change",
          },
        ],
        // image: [
        //   {
        //     type: "array",
        //     required: true,
        //     message: "请至少选择图片",
        //     trigger: "change",
        //   },
        // ],
        address: [
          { required: true, message: "请输入报事地点", trigger: "blur" },
        ],
        des: [{ required: true, message: "请填写描述", trigger: "blur" }],
      },
      parkList: [],
      companyList: [],
      maintenanceList: [],
      maintenanceTwoList: [],
      ageUserList: [],
      ByUserList: [],
    };
  },
  created() {
    if (this.userInfo.is_super !== 1) {
      this.ruleForm.park_id = this.userInfo.park_id;
      this.changePark(this.userInfo.park_id);
    }
    if (this.userInfo.type == 2) {
      this.ruleForm.company_id = this.userInfo.company_id;
      this.getAgoList(this.userInfo.company_id);
    }
    // this.getPark();
    this.changePark()
  },
  methods: {
    // 获取报事人
    getAgoList(id) {
      openAgoUser({ company_id: id, type: 2, is_page: 2,is_youke:2 }).then((res) => {
        this.ageUserList = res.data.lists;
      });
    },
    // 获取接收人列表
    getByMaintenanceTypeUrse(typeId) {
      getByUser({ park_id: this.$store.state.mainParkId, type_id: typeId }).then(
        (res) => {
          this.ByUserList = res.data.lists;
        }
      );
    },
    // 选中园区
    changePark(e) {
      this.ruleForm.user_id = "";
      this.ruleForm.company_id = "";
      this.ruleForm.maintenance_type_id = "";
      this.ruleForm.maintenance_type_son_id = "";
      this.ruleForm.dispose_user_id = "";
      this.getMaintenanceList(e);
      this.getCompany(e);
    },
    // 选中企业
    changeCompany(e) {
      this.ruleForm.user_id = "";
      this.getAgoList(e);
    },
    // 选中原因大类
    changeType(e, c) {
      this.ruleForm.maintenance_type_son_id = "";
      this.ruleForm.dispose_user_id = "";
      this.getMaintenanceTwoList(e);
      this.getByMaintenanceTypeUrse(e);
    },
    // 选中得小类
    reasonSmall(e) {
      this.ruleForm.dispose_user_id = "";
      if (e) {
        this.getByMaintenanceTypeUrse(e);
      } else {
        this.getByMaintenanceTypeUrse(this.ruleForm.maintenance_type_id);
      }
    },
    // 获取报事报修原因类型小类列表数据
    getMaintenanceTwoList(id) {
      maintenanceType({
        pid: id,
        level: 2,
        is_page: 2,
        status: 1,
        park_id: this.$store.state.mainParkId,
      }).then((res) => {
        this.maintenanceTwoList = res.data.lists;
      });
    },
    // 获取报事报修原因类型列表数据
    getMaintenanceList(id) {
      maintenanceType({ level: 1, park_id: this.$store.state.mainParkId, is_page: 2, status: 1 }).then(
        (res) => {
          this.maintenanceList = res.data.lists;
        }
      );
    },
    // 获取企业
    getCompany(parkId) {
      openCompany({ park_id: this.$store.state.mainParkId, is_page: 2, status: 1 }).then(
        (response) => {
          this.companyList = response.data.lists;
        }
      );
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.ruleForm.image.push(res.data.url[0]);
      }
      this.uploadDisabled = this.ruleForm.image >= 6;
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 删除
    handleRemove(file) {
      const index = this.ruleForm.image.indexOf(file.response.data.url);
      this.delImg(file.response.data.url);
      if (index > -1) {
        this.ruleForm.image.splice(index, 1);
      }
    },
    // 查看
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 删除线上图片
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    // 最多上传6张图，超过时隐藏上传按钮
    handleEditChange(file, fileList) {
      this.uploadDisabled = this.ruleForm.image.length >= 6;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.image = this.ruleForm.image.toString();
          this.ruleForm.park_id = this.$store.state.mainParkId
          addProprietor(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.resetForm("ruleForm");
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
    },
  },
};
</script>
<style lang="scss" scoped>
.formBox {
  padding: 20px 30px;
}

::v-deep .el-form-item__label {
  line-height: 0;
}

::v-deep .disabled .el-upload--picture-card {
  display: none !important;
}

::v-deep .w50 {
  .el-textarea {
    width: 45%;
  }
  .el-input {
    width: 45%;
  }
}
</style>
